export const API_ENDPOINT = 'https://dev-challenge-api.devlabs-projects.info/api/';

/**
 * TODO: This is a workaround for development.
 * Remove when the process is configured for production!
 */

export const APPLICATION_TOKEN = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImMxNGJlYzczYzQ4YTM1Y2RiYjU3ZDczYzVmODkyZGU1ZGVlMzkxNjFjZGJkZGNiNjE0ZWU0OWFhODFkMTVkOGU1MGJiZTZkM2VhODNmNmUwIn0.eyJhdWQiOiIxIiwianRpIjoiYzE0YmVjNzNjNDhhMzVjZGJiNTdkNzNjNWY4OTJkZTVkZWUzOTE2MWNkYmRkY2I2MTRlZTQ5YWE4MWQxNWQ4ZTUwYmJlNmQzZWE4M2Y2ZTAiLCJpYXQiOjE0OTQ0OTY4NzcsIm5iZiI6MTQ5NDQ5Njg3NywiZXhwIjoyMTI1NjQ4ODc3LCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.CdcXnfAeb2ah3Vdx4c-NMIZ4n_YQjmd0NyrDkjGHwqF18M5UazTTrhS4C5xwFFuaTh7-b54r61tqRwk5soUmiv3O7qEznzAHOEGC8LBkOO9uyjIWIXLWupHTRYHPbkC03Xohxmc04Oi56-kWod3gZ3fFni7Jh0Ce4z6r-xjVI4MlfGBN6Aio-JqAvidoDgy3JjAlgaDvg1YlEHAHBnlvB7wIEdsyp7zIuqd2fj1481ijCLtRgJYqtHWVsY4p3vpUou_NTzGjQ49l-G-U_fzeQAd3nZy7x6I11GlfwZAhL4vv1Ej1_mScJuKVXuLGMEGWtRNP_nY88B_7NbIT9gRx-tpsmH4PvtchQVMNtyE3eKRFaCS333EQLM4ga5aVKMYGlelY-xyQC8KkZKd6i12uFwHomGcOEDvJLPWYF1krbOYmlOsey55WQ4KzbCKvmy9eSFmfn4yRzNIiDaVbus9Gcuh1MyUr9Jovw_T_Z73l_OnOg8wmhGtamhspygoQagNcdhuSF6H21239V2OMJaSge4MuUeiY8D9Y8xXSEOHn5RQf7KhJ5tIbgmfQccRVko2gDJYUdO81ryZD_zBYK1yzFFiPbbh2qblLnQ02QNj1RP5hmzUIrO-6XDQEtpg3FGPRxh-zEOc7TE2MnqYSP8x4fU-NHVoQVxxhqNe67EY0pE0';

/**
 * App keys for one signal
 * notification service
 * 
 * @type {String}
 */
export const ONE_SIGNAL_APP_KEY = "MTNlMGRjMjgtMmFhOS00YWY3LWJlNDktMTc4YzBhZDA2NTgw"; // for chrome and firefox
export const ONE_SIGNAL_SAFARI = "XXXXXXX"; // for safari

/**
 * Github Login Url
*/
export const GITHUB_ENDPOINT = "https://dev-challenge.devlabs-projects.info/auth/github";



// WEBPACK FOOTER //
// ./src/app/config.ts